import { MonthlyExceptionReportM2m } from './../../model/monthly-exception-report-m2m';
import { PdfFileService } from './../../services/pdf-file.service';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from './../../services/excel-file.service';
import { FileExportService } from './../../services/file-export.service';
import { ReportDateRangeDto } from './../../model/report-date-range-dto';
import { HttpclientService } from './../../services/httpclient.service';
import { AppSettingService } from './../../services/app-setting.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import * as moment from 'moment';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { ExceptionReportDto } from 'src/app/model/exception-report-dto';
import { ModalModule, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-monthly-exceptions-report-m2-m',
  templateUrl: './monthly-exceptions-report-m2-m.component.html',
  styleUrls: ['./monthly-exceptions-report-m2-m.component.css']
})
export class MonthlyExceptionsReportM2MComponent implements OnInit {
maxDateMerm: moment.Moment;
dateRangeMerm;
dateRangeStartMerm;
dateRangeEndMerm;
exportModalMerm: string;
selectAllRowModalMerm: boolean;
public loadingMerm: boolean;
public paginationConfigurationMerm;
reportDateRangeDto: ReportDateRangeDto;
// exceptionReportDtoM2mList: ExceptionReportDto[];
exceptionReportDtoM2mList1: MonthlyExceptionReportM2m[];
exceptionReportDtoM2mSelectedList: ExceptionReportDto[];
exceptionReportDtoM2mSelectedList1: MonthlyExceptionReportM2m[];
selectedMermDto: any = [];
paginationCountMerm = 25;
modalRef: BsModalRef;
responseContents: any;

isCreatedDateUpArrow: boolean;
isCreatedDateDownArrow: boolean;
isMsoUpArrow: boolean;
isMsoDownArrow: boolean;
isYearUpArrow: boolean;
isYearDownArrow: boolean;
isMonthTextArrow: boolean;
isMonthTextDownArrow: boolean;
isDistributorPayerUpArrow: boolean;
isDistributorPayerDownArrow: boolean;
isPurchaseOrderNumberTextArrow: boolean;
isPurchaseOrderNumberTextDownArrow: boolean;
isItemErrorCodeTextArrow: boolean;
isItemErrorCodeTextDownArrow: boolean;
isItemErrorDescriptionTextArrow: boolean;
isItemErrorDescriptionTextDownArrow: boolean;
isSupplierDocRefNumberTextArrow: boolean;
isSupplierDocRefNumberTextDownArrow: boolean;
isAxaltaCartKeyTextArrow: boolean;
isAxaltaCartKeyTextDownArrow: boolean;

sortArry: ExceptionReportDto[];
sortArry1: MonthlyExceptionReportM2m[];
  constructor(public appSettingService: AppSettingService, private httpclientService: HttpclientService,
              public fileExportService: FileExportService, public excelFileService: ExcelFileService, public datePipe: DatePipe,
              public pdfFileService: PdfFileService, private pipe: PoOrderByPipe, private modalService: BsModalService) { }

  ngOnInit() {
    this.maxDateMerm = moment().add(0, 'days');
    this.exportModalMerm = this.appSettingService.exportList[0];
    this.paginationConfigurationMerm = { currentPage: '25 per page', itemsPerPage: '25' };
    this.dateRangeMerm = '';
    this.exceptionReportDtoM2mList1 =[];
    this.initialSortValue();
  }


  



/****************************************************** Clear Selction Start ***************************************************/


initialSortValue() {

  
  this.isCreatedDateUpArrow= true;
  this.isCreatedDateDownArrow= true;
  this.isMsoUpArrow= true;
  this.isMsoDownArrow= true;
  this.isYearUpArrow= true;
  this.isYearDownArrow= true;
  this.isMonthTextArrow= true;
  this.isMonthTextDownArrow= true;
  this.isDistributorPayerUpArrow= true;
  this.isDistributorPayerDownArrow= true;
  this.isPurchaseOrderNumberTextArrow= true;
  this.isPurchaseOrderNumberTextDownArrow= true;
  this.isItemErrorCodeTextArrow= true;
  this.isItemErrorCodeTextDownArrow= true;
  this.isItemErrorDescriptionTextArrow= true;
  this.isItemErrorDescriptionTextDownArrow= true;
  this.isSupplierDocRefNumberTextArrow= true;
  this.isSupplierDocRefNumberTextDownArrow= true;
  this.isAxaltaCartKeyTextArrow =true
  this.isAxaltaCartKeyTextDownArrow =true
}
  clearAllSelection() {
     this.selectAllRowModalMerm = false;
     this.initialSortValue();
    // this.clearMlrSelection = [];
    // this.monthlyLocationDtoList.forEach(pdto => {
    //   pdto.rowCheck = false;
    //   this.clearMlrSelection.push(pdto);
    // });
    // this.monthlyLocationDtoList = this.clearMlrSelection;
  }
/****************************************************** Clear Selction End ***************************************************/



/****************************************************** Date Picker Block Start ***************************************************/
dateOnChangeMerm(){
  this.fileExportService.selectedMonthlyExceptionsReportM2MData = [];
  this.exceptionReportDtoM2mList1=[];
  if (this.dateRangeMerm.dateRangeStartMerm !== undefined &&
    this.dateRangeMerm.dateRangeStartMerm !== null) {
    this.loadingMerm = true;
    this.reportDateRangeDto = {
      start: this.dateRangeMerm.dateRangeStartMerm.format('YYYY-MM-DD'),
      end: this.dateRangeMerm.dateRangeEndMerm.format('YYYY-MM-DD'),
    };
    this.httpclientService.getMonthlyExceptionsReportM2M(this.reportDateRangeDto).subscribe(
      data => {
        this.loadingMerm = false;
        this.clearAllSelection();
        this.exceptionReportDtoM2mList1 = data;
      }
    );
  }
}

/****************************************************** Date Picker Block End ***************************************************/


/****************************************************** File Export Start ***************************************************/
exportDataOnChangeMerm(exportData) {
  this.exportModalMerm = exportData;
}
modalPopup : boolean=false;
modalPopupString: string;
pressingOK(){
  this.modalPopup=false;
}

exportFileOnClickMerm() {
  console.log('.....this.fileExportService.selectedMonthlyExceptionsReportM2MData1..' + this.fileExportService.selectedMonthlyExceptionsReportM2MData1.length);
  if (this.exceptionReportDtoM2mList1 === null || this.exceptionReportDtoM2mList1 == undefined || this.exceptionReportDtoM2mList1.length ===0) {
    this.modalPopupString="No Data to Export";
    this.modalPopup=true;
    return ;
   }// else
   if (this.fileExportService.selectedMonthlyExceptionsReportM2MData1.length === 0 && this.exceptionReportDtoM2mList1.length !== 0) {
    if (this.exportModalMerm === 'PDF') {
      this.pdfFileService.exportMonthlyExceptionReportM2mPdfAll('Monthly Exceptions Report M2M', this.exceptionReportDtoM2mList1);
    } else if (this.exportModalMerm === 'Excel') {
      this.selectedMermDto = [];
      this.exceptionReportDtoM2mList1.forEach(pdto => {
         
          let createdDate: any;
          let mso: any;
          let year: any;
          let month: any;
          let distributorPayer: any;
          let purchaseOrderNumber: any;
          let itemErrorCode: any;
          let itemErrorDescription: any;
          let supplierDocRefNumber: any;
          let axaltaCartKey: any;
          if (pdto.createdDate === null) {
            createdDate = '';
          } else {
            createdDate = this.datePipe.transform(pdto.createdDate, this.appSettingService.globelDatePickerInUSAFormat);
          }
          if (pdto.mso === null) {
            mso = '';
          } else {
            mso = pdto.mso;
          }
          if (pdto.year === null) {
            year = '';
          } else {
            year = pdto.year;
          }
          if (pdto.month === null) {
            month = '';
          } else {
            month = pdto.month;
          }
          if (pdto.distributorPayer === null) {
            distributorPayer = '';
          } else {
            distributorPayer = pdto.distributorPayer;
          }
          if (pdto.purchaseOrderNumber === null) {
            purchaseOrderNumber = '';
          } else {
            purchaseOrderNumber = pdto.purchaseOrderNumber;
          }
          if (pdto.itemErrorCode === null) {
            itemErrorCode = '';
          } else {
            itemErrorCode = pdto.itemErrorCode;
          }
          if (pdto.itemErrorDescription === null) {
            itemErrorDescription = '';
          } else {
            itemErrorDescription = pdto.itemErrorDescription;
            var fixedSize=51;
            var minLength=0;
            if(itemErrorDescription.length > fixedSize){
              var totalLines = itemErrorDescription.length/fixedSize;
              for(var i=0; i<totalLines;i++){
                this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
                minLength=fixedSize;
                fixedSize=2*fixedSize;
  
              }
              itemErrorDescription=this.copyOfItemErrorDescription;
              this.copyOfItemErrorDescription="";
            }
          }
          if (pdto.supplierDocRefNumber === null) {
            supplierDocRefNumber = '';
          } else {
            supplierDocRefNumber = pdto.supplierDocRefNumber;
          }
          if (pdto.axaltaCartKey === null) {
            axaltaCartKey = '';
          } else {
            axaltaCartKey = pdto.axaltaCartKey;
          }

          this.selectedMermDto.push({
            'Created Date': createdDate, MSO: mso,
            Year: `` + year, Month: `` + month,
            'Distributor Payer': `` + distributorPayer, 'Purchase Order Number': `` + purchaseOrderNumber,'SupplierDocRefNumber': `` + supplierDocRefNumber
            , 'Item Error Code': `` + itemErrorCode, 'Item Error Description': `` + itemErrorDescription
            , 'Cart Key': `` + axaltaCartKey
          });
        
      });
      this.excelFileService.exportMonthlyExceptionReportM2mExcel(this.selectedMermDto, 'Monthly Exceptions Report M2M');
    }

  } else if( this.fileExportService.selectedMonthlyExceptionsReportM2MData1.length !== 0 && this.exceptionReportDtoM2mList1.length !== 0) {
    if (this.exportModalMerm === 'PDF') {
      this.pdfFileService.exportMonthlyExceptionReportM2mPdf('Monthly Exceptions Report M2M');
    } else if (this.exportModalMerm === 'Excel') {
      this.selectedMermDto = [];
      this.fileExportService.selectedMonthlyExceptionsReportM2MData1.forEach(pdto => {
        if (pdto.rowCheck) {
          
          let createdDate: any;
          let mso: any;
          let year: any;
          let month: any;
          let distributorPayer: any;
          let purchaseOrderNumber: any;
          let itemErrorCode: any;
          let itemErrorDescription: any;
          let supplierDocRefNumber: any;
          let axaltaCartKey: any;
          if (pdto.createdDate === null) {
            createdDate = '';
          } else {
            createdDate = this.datePipe.transform(pdto.createdDate, this.appSettingService.globelDatePickerInUSAFormat);
          }
          if (pdto.mso === null) {
            mso = '';
          } else {
            mso = pdto.mso;
          }
          if (pdto.year === null) {
            year = '';
          } else {
            year = pdto.year;
          }
          if (pdto.month === null) {
            month = '';
          } else {
            month = pdto.month;
          }
          if (pdto.distributorPayer === null) {
            distributorPayer = '';
          } else {
            distributorPayer = pdto.distributorPayer;
          }
          if (pdto.purchaseOrderNumber === null) {
            purchaseOrderNumber = '';
          } else {
            purchaseOrderNumber = pdto.purchaseOrderNumber;
          }
          if (pdto.itemErrorCode === null) {
            itemErrorCode = '';
          } else {
            itemErrorCode = pdto.itemErrorCode;
          }
          if (pdto.itemErrorDescription === null) {
            itemErrorDescription = '';
          } else {
            itemErrorDescription = pdto.itemErrorDescription;
            var fixedSize=51;
            var minLength=0;
            if(itemErrorDescription.length > fixedSize){
              var totalLines = itemErrorDescription.length/fixedSize;
              for(var i=0; i<totalLines;i++){
                this.copyOfItemErrorDescription =this.copyOfItemErrorDescription+ itemErrorDescription.substring(minLength,fixedSize)+"\r";
                minLength=fixedSize;
                fixedSize=2*fixedSize;
  
              }
              itemErrorDescription=this.copyOfItemErrorDescription;
              this.copyOfItemErrorDescription="";
            }
          }
          if (pdto.supplierDocRefNumber === null) {
            supplierDocRefNumber = '';
          } else {
            supplierDocRefNumber = pdto.supplierDocRefNumber;
          }
          if (pdto.axaltaCartKey === null) {
            axaltaCartKey = '';
          } else {
            axaltaCartKey = pdto.axaltaCartKey;
          }
          this.selectedMermDto.push({
            'Created Date': createdDate, MSO: `${pdto.mso}`,
            Year: `` + year, Month: `` + month,
            'Distributor Payer': `` + distributorPayer, 'Purchase Order Number': `` + purchaseOrderNumber,'SupplierDocRefNumber': `` + supplierDocRefNumber
            , 'Item Error Code': `` + itemErrorCode, 'Item Error Description': `` + itemErrorDescription
            , 'Cart Key': `` + axaltaCartKey
          });
        }
      });
      this.excelFileService.exportMonthlyExceptionReportM2mExcel(this.selectedMermDto, 'Monthly Exceptions Report M2M');
    }
  }
}
copyOfItemErrorDescription: string="";
/****************************************************** File Export End ***************************************************/



/****************************************************** Row Selection Start ***************************************************/
onSelectParticularRowMerm(selectedItem: any, values: any) {
  if (values.currentTarget.checked) {
    this.fileExportService.selectedMonthlyExceptionsReportM2MData1.push(selectedItem);
  } else if (!values.currentTarget.checked) {
    this.fileExportService.selectedMonthlyExceptionsReportM2MData1 = this.fileExportService.selectedMonthlyExceptionsReportM2MData1.filter(obj => obj !== selectedItem);
  }
  if (this.fileExportService.selectedMonthlyExceptionsReportM2MData1.length === this.exceptionReportDtoM2mList1.length) {
    this.selectAllRowModalMerm = true;
  } else {
    this.selectAllRowModalMerm = false;
  }
}

onSelectAllRowMerm(values: any) {
 this.exceptionReportDtoM2mSelectedList1 = [];
if (values.currentTarget.checked) {
  this.exceptionReportDtoM2mList1.forEach(pdto => {
    pdto.rowCheck = true;
    this.exceptionReportDtoM2mSelectedList1.push(pdto);
  });
  this.exceptionReportDtoM2mList1 = this.exceptionReportDtoM2mSelectedList1;
  this.fileExportService.selectedMonthlyExceptionsReportM2MData1 = this.exceptionReportDtoM2mSelectedList1;
} else {
  this.exceptionReportDtoM2mList1.forEach(pdto => {
    pdto.rowCheck = false;
    this.exceptionReportDtoM2mSelectedList1.push(pdto);
  });
  this.exceptionReportDtoM2mList1 = this.exceptionReportDtoM2mSelectedList1;
  this.fileExportService.selectedMonthlyExceptionsReportM2MData1 = [];
}
 }

/****************************************************** Row Selection End ***************************************************/



/****************************************************** Pagination Start ***************************************************/
onChangePaginationMerm(value) {

  this.paginationConfigurationMerm.itemsPerPage = value;
  this.paginationCountMerm = value;
}

pageOnChangedMerm(event) {
  this.paginationConfigurationMerm.currentPage = event;
}
/****************************************************** Pagination End ***************************************************/


/****************************************************** Modal Start ***************************************************/

openModalMerm(template: TemplateRef<any>, responseContent: any) {
  this.responseContents = '';
  this.responseContents = responseContent;
  this.modalRef = this.modalService.show(template);
}

/****************************************************** Modal End ***************************************************/

/****************************************************** Table Sort Start ***************************************************/
onChangeMermSort(event: any, upDown: boolean, propertyName: string) {
  if (propertyName === 'createdDate' ) {
    
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isPurchaseOrderNumberTextArrow= true;
    this.isPurchaseOrderNumberTextDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isCreatedDateUpArrow = !this.isCreatedDateUpArrow;
  this.isCreatedDateDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isCreatedDateDownArrow = !this.isCreatedDateDownArrow;
this.isCreatedDateUpArrow = true;
}
  } else if (propertyName === 'mso' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isPurchaseOrderNumberTextArrow= true;
    this.isPurchaseOrderNumberTextDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isMsoUpArrow = !this.isMsoUpArrow;
  this.isMsoDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isMsoDownArrow = !this.isMsoDownArrow;
this.isMsoUpArrow = true;
}
  } else if (propertyName === 'year' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isPurchaseOrderNumberTextArrow= true;
    this.isPurchaseOrderNumberTextDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isYearUpArrow = !this.isYearUpArrow;
  this.isYearDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isYearDownArrow = !this.isYearDownArrow;
this.isYearUpArrow = true;
}
  } else if (propertyName === 'month' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isPurchaseOrderNumberTextArrow= true;
    this.isPurchaseOrderNumberTextDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isMonthTextArrow = !this.isMonthTextArrow;
  this.isMonthTextDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isMonthTextDownArrow = !this.isMonthTextDownArrow;
this.isMonthTextArrow = true;
}
  } else if (propertyName === 'distributorPayer' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isPurchaseOrderNumberTextArrow= true;
    this.isPurchaseOrderNumberTextDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isDistributorPayerUpArrow = !this.isDistributorPayerUpArrow;
  this.isDistributorPayerDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isDistributorPayerDownArrow = !this.isDistributorPayerDownArrow;
this.isDistributorPayerUpArrow = true;
}
  } else if (propertyName === 'purchaseOrderNumber' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isPurchaseOrderNumberTextArrow = !this.isPurchaseOrderNumberTextArrow;
  this.isPurchaseOrderNumberTextDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isPurchaseOrderNumberTextDownArrow = !this.isPurchaseOrderNumberTextDownArrow;
this.isPurchaseOrderNumberTextArrow = true;
}
  } else if (propertyName === 'itemErrorCode' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isItemErrorCodeTextArrow = !this.isItemErrorCodeTextArrow;
  this.isItemErrorCodeTextDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isItemErrorCodeTextDownArrow = !this.isItemErrorCodeTextDownArrow;
this.isItemErrorCodeTextArrow = true;
}
  } else if (propertyName === 'itemErrorDescription' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isItemErrorDescriptionTextArrow = !this.isItemErrorDescriptionTextArrow;
  this.isItemErrorDescriptionTextDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isItemErrorDescriptionTextDownArrow = !this.isItemErrorDescriptionTextDownArrow;
this.isItemErrorDescriptionTextArrow = true;
}
  } else if (propertyName === 'supplierDocRefNumber' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isAxaltaCartKeyTextArrow =true
    this.isAxaltaCartKeyTextDownArrow =true
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isSupplierDocRefNumberTextArrow = !this.isSupplierDocRefNumberTextArrow;
  this.isSupplierDocRefNumberTextDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isSupplierDocRefNumberTextDownArrow = !this.isSupplierDocRefNumberTextDownArrow;
this.isSupplierDocRefNumberTextArrow = true;
}
  }
  else if (propertyName === 'axaltaCartKey' ) {
    this.isCreatedDateUpArrow= true;
    this.isCreatedDateDownArrow= true;
    this.isMsoUpArrow= true;
    this.isMsoDownArrow= true;
    this.isYearUpArrow= true;
    this.isYearDownArrow= true;
    this.isMonthTextArrow= true;
    this.isMonthTextDownArrow= true;
    this.isDistributorPayerUpArrow= true;
    this.isDistributorPayerDownArrow= true;
    this.isItemErrorCodeTextArrow= true;
    this.isItemErrorCodeTextDownArrow= true;
    this.isItemErrorDescriptionTextArrow= true;
    this.isItemErrorDescriptionTextDownArrow= true;
    this.isSupplierDocRefNumberTextArrow= true;
    this.isSupplierDocRefNumberTextDownArrow= true;
    
    if (upDown) {
  this.sortArry1 = [];
  this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
  this.exceptionReportDtoM2mList1 = [];
  this.exceptionReportDtoM2mList1 = this.sortArry1;
  this.isAxaltaCartKeyTextArrow = !this.isAxaltaCartKeyTextArrow;
  this.isAxaltaCartKeyTextDownArrow = true;
} else {
this.sortArry1 = [];
this.sortArry1 = this.pipe.transform(this.exceptionReportDtoM2mList1, propertyName, upDown);
this.exceptionReportDtoM2mList1 = [];
this.exceptionReportDtoM2mList1 = this.sortArry1;
this.isAxaltaCartKeyTextDownArrow = !this.isAxaltaCartKeyTextDownArrow;
this.isAxaltaCartKeyTextArrow = true;
}
  }
}



/****************************************************** Table Sort Start ***************************************************/

}
